import styled from 'styled-components'

interface InputWrapProps {
  bordercolor: string
  backgroundcolor: string
  outlinecolor?: string
}

export const InputWrap = styled.div<InputWrapProps>`
  overflow: hidden;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
  border: 1px solid ${(props) => props.bordercolor};
  background-color: ${(props) => props.backgroundcolor};
  transition: 0.1s;
  outline: none;
  cursor: text;
  position: relative;

  &:focus-within {
    outline: 1px solid
      ${(props) =>
        props.outlinecolor
          ? props.outlinecolor
          : props.theme.color.neutral.gray};
  }
`
